<div class="stats-history-dialog"
     cdkDrag
     cdkDragRootElement=".cdk-overlay-pane"
     cdkDragBoundary=".cdk-overlay-container">
  <!-- Fejléc -->
  <div class="dialog-header" mat-dialog-title cdkDragHandle>
    <mat-icon class="header-icon">history</mat-icon>
    <span class="header-title">
      Módosítási napló – {{ data.colleagueName }} ({{ data.month }} {{ data.year }})
    </span>
    <button mat-icon-button class="close-btn" (click)="onClose()" matTooltip="Bezárás">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <!-- Betöltés -->
    @if (loading) {
      <div class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Naplóbejegyzések betöltése...</p>
      </div>
    }

    <!-- Hiba -->
    @else if (error) {
      <div class="error-state">
        <mat-icon>error_outline</mat-icon>
        <p>{{ error }}</p>
        <button mat-stroked-button (click)="loadLogs()">
          <mat-icon>refresh</mat-icon> Újrapróbálás
        </button>
      </div>
    }

    <!-- Üres állapot -->
    @else if (!paginatedLogs.length) {
      <div class="empty-state">
        <mat-icon>info_outline</mat-icon>
        <p>Nincs tervszám- vagy tényszám-módosítási bejegyzés ebben a hónapban.</p>
      </div>
    }

    <!-- Log táblázat -->
    @else {
      <app-extended-logs-table
        [paginatedLogs]="paginatedLogs"
        [loading]="loading"
        [error]="error"
        [totalLogs]="totalLogs"
        [hidePaginator]="true">
      </app-extended-logs-table>
    }
  </mat-dialog-content>

</div>
